export enum AiModelTypes
{
    IMAGE = 'image',
    TEXT = 'text',
    EMBEDDING = 'embedding',
    TTS = 'tts',
    VISION = 'vision',
    ASSISTANT = 'assistant'
}

export enum AiProviders
{
    AZURE = 'Azure',
    AZUREOPENAI = 'Azure OpenAi',
    REPLICATE = 'Replicate',
    OPENAI = 'OpenAI',
    ANTHROPIC = 'Anthropic',
    GOOGLE = 'Google',
    ELEVENLABS = 'ElevenLabs',
    SELFHOSTED = 'Selfhosted'
}
